/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";
import { getCareerCoreValues } from "../Service/CareerApi";
import { API_BASE_IMG_URl } from "helper/environment";
import './StoriesTeam.css'
import Typewriter from "typewriter-effect";
import TypedText from "components/Homes/typewrite";
const CORE_VALUES_UUID = "07130061-f1bd-4667-a953-aa2a24ec9efb";
const CareerInfo: React.FC = () => {
  const [node, setNode] = useState<any>(null);
 
  useEffect(() => {
    getCareerCoreValues(CORE_VALUES_UUID)
      .then((res) => {
        setNode(res.data);
       
      })
      .catch(console.error);
  }, []);
        const [isMobile, setIsMobile] = useState(false);
  
    useEffect(() => {
      const checkScreen = () => {
        setIsMobile(window.innerWidth < 768);
      };
  
      checkScreen();
      window.addEventListener("resize", checkScreen);
  
      return () => window.removeEventListener("resize", checkScreen);
    }, []); 
  if (!node) return null;
  //console.log(node)
  return (
   <section id="career-info" className="careers-cta-section career-section position-relative bg-light text-center">
    <div className="container position-relative z-1">
        <div
          className="section-title  text-center mx-auto mb-3 wow fadeInUp clearfix"
          data-wow-delay="0.1s"  style={{
    animation: 'fadeInMiddle 0.8s ease-in-out both',
  }}
        >
         
          <h2 className="mb-3">
            <TypedText
              index={1}
              text={`<span class='text-dark'>${node.attributes.field_maintitle}</span> ${node.attributes.field_subtitle}`}
              delay={100}
              cursor="|"
            />
          </h2>
        </div>
     
      
      <p className="text-secondary mb-3 mx-auto small-text-muted" dangerouslySetInnerHTML={{
                              __html: node.attributes.field_content.value}} />
       
      <div className="d-inline-flex align-items-center justify-content-center gap-3 mt-2 email-anchor-wrap">
        <div className="mail-icon-box d-flex align-items-center">
          <a href={`mailto:${node.attributes.field_email_id}`} >
          <i className={`${node.attributes.field_icon_class} ${isMobile ? 'fa-2x' : 'fa-3x'} text-primary`}></i>
          </a>
        </div>
        <a href={`mailto:${node.attributes.field_email_id}`} className="cta-email-link text-decoration-none fw-medium text-dark h4 mb-0">
          {node.attributes.field_email_id}
        </a>
      </div>

    </div>

  
  </section>

  )
};
export default CareerInfo;      